import { Flex, FontSize, Label, Text } from 'src/components';
import { colors } from "src/theme";

interface DescriptionItemProps {
  label: React.ReactNode;
  value?: React.ReactNode;
  labelSize?: "large" | "medium" | "small" | "tiny";
  valueSize?: FontSize;
  labelColor?: string;
  valueColor?: string;
  bold?: boolean;
}

export const DescriptionItem: React.FC<DescriptionItemProps> = ({ 
  label, 
  value, 
  labelSize = 'small', 
  valueSize = 'base',
  labelColor = colors.text4,
  valueColor = colors.text1,
  bold = false
}) => {
  const isString = (v: any): v is string => typeof v === 'string';

  return (
    <Flex vertical>
      <Label type={labelSize} color={labelColor} bold={bold}>{label}</Label>
      {isString(value) ? (
        <Text type={valueSize} color={valueColor} >{value}</Text>
      ) : (
        value
      )}
    </Flex>
  )
};

